export const GOOGLE = 'GOOGLE';
export const FACEBOOK = 'FACEBOOK';
export const ALLOCINE = 'ALLOCINE';

export enum IdentityProviderTypes {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK'
}
